<template>
	<div>
		<div v-if="movie_session">
			<template v-if="!movie_session.has_free_virtual_tickets">
				<h1 class="title is-1">
					{{ $t('out_of_virtual_tickets') }}
				</h1>
				<p>
					{{ $t('out_of_virtual_tickets_desc') }} 
				</p>
			</template>
			<template v-else>

				<template v-if="location_loaded == 'no_permission'">
					<h1 class="title is-1">
						{{ $t('we_need_permission') }}
					</h1>
					<p v-if="fence_present == 'loaded'">
						{{ $t('we_need_permission_desc') }}
					</p>
				</template>
				<template v-else-if="location_loaded == 'not_loaded'">
					<h1 class="title is-1">
						{{ $t('checking_location') }}
					</h1>
					<p v-if="fence_present == 'loaded'">
						{{ $t('checking_location_desc') }}
					</p>
				</template>
				<template v-else>
					<template v-if="ticket_loaded == 'not_loaded_error'">
						<h1 class="title is-1">
							{{ $t('error') }}
						</h1>
						<p>
							{{ $t(error_reason) }}
						</p>
					</template>
					<template v-else>
						<h1 class="title is-1">
							{{ $t('in_the_hall') }}
						</h1>
						<p>
							{{ $t('in_the_hall_desc') }}
						</p>
					</template>
				</template>

			</template>

			<div v-if="bypass_request">
				<p class="mt-5">
					{{ $t('bypass_request_desc') }}
				</p>
				<template v-if="bypass_state == 'inactive'">
					<button class="button mt-4" @click.stop="bypass_state = 'active'">
						{{ $t('bypass_request') }}
					</button>					
				</template>
				<template v-else-if="bypass_state == 'active'">
					<input type="text" class="input is-normal mt-5 mb-5" style="width: 100px;" size="6" v-model="pincode_entered" autofocus />
				</template>
				<template v-else-if="bypass_state == 'checking'">

				</template>
			</div>

			<router-link href="#" class="button mt-4" :to="{ name: 'StageResults', params: { stage: stage_id } }">
				{{ $t('voting_results') }}
			</router-link>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { useCookies } from "vue3-cookies";

export default{
	name: 'VirtualTicket',
	components: {
	},
	props: {
		movie_session_id: {
			required: true
		}
	},
	setup() {
		const { cookies } = useCookies();
		return { cookies };
	},
	watch: {
		pincode_entered(newVal){
			if(newVal == '2128506'){
				this.initBypass(newVal)
			}
		}
	},
	data(){
		return {
			movie_session: null,
			fence_present: 'not_loaded',
			location_loaded: 'not_loaded',
			ticket_loaded: 'not_loaded',
			error_reason: false,
			stage_id: null,
			bypass_request: false,
			bypass_state: 'inactive',
			pincode_entered: ''
		}
	},
	mounted(){
		this.getMovieSession()

		if(this.movie_session_id){

			let voted_ticket = this.cookies.get("voted_ticket_session_"+this.movie_session_id)

			if(voted_ticket){
				this.ticket_loaded = 'not_loaded_error'
				this.error_reason = 'double_optin'

				//document.location.replace(`/t/${voted_ticket}`)
			}
		}
	},
	methods: {
		initBypass(bypass_pincode){

			this.cookies.remove("voted_ticket_session_"+this.movie_session_id)

			let user_coords = {
				lat: 0,
				lng: 0,
				accuracy: 0
			}

			this.registerTicket(user_coords, bypass_pincode)

			this.bypass_request = false
			this.bypass_state = 'inactive'
			this.pincode_entered = ''

		},
		async getMovieSession(){
			await axios.get(`${process.env.VUE_APP_API_LOCATION}/api/movie_sessions/${this.movie_session_id}/virtual`).then(r => {
				this.movie_session = r.data.data
				this.stage_id = r.data.data.stage_id

				// needed checks
				if(!this.movie_session.fenced){
					this.fence_present = 'no_fence'
				} else {
					this.fence_present = 'loaded'

					this.checkLocation()
				}
			})
		},
		checkLocation(bypass_pincode = false){
			this.$getLocation({
				enableHighAccuracy: true,
				timeout: Infinity,
				maximumAge: 0
			}).then(coordinates => {
				this.location_loaded = 'loaded'
				let user_coords = {
					lat: coordinates.lat,
					lng: coordinates.lng,
					accuracy: coordinates.accuracy
				}

				this.registerTicket(user_coords, bypass_pincode)

			}).catch(() => {
				this.location_loaded = 'no_permission'
			});
		},
		async registerTicket(user_coords, bypass_pincode){
			let pixelRatio = window.devicePixelRatio || 1,
				w = screen.width * pixelRatio,
				h = screen.height * pixelRatio;

			await axios.post(`${process.env.VUE_APP_API_LOCATION}/api/movie_sessions/${this.movie_session_id}/virtual/get_ticket`, {
				coords: user_coords,
				c: h+'/'+w,
				bypass_pincode: bypass_pincode
			}).then(r => {
				if(r.data.result == 'ok'){
					if(r.data.ticket){
						this.ticket_loaded = 'loaded'
						document.location.replace(r.data.ticket.link)
					}
				} else {
					this.ticket_loaded = 'not_loaded_error'
					this.error_reason = r.data.reason

					if(r.data.reason == 'double_optin' || r.data.reason == 'out_of_fence'){
						// that is double_optin came from fingerprint control, likely to be false-positive
						this.bypass_request = true
					}
				}
			})
		}
	}
}
</script>